import nf from "@tuplo/numberfmt";

export const formatData = (value: number | string | Date, format?: any) => {
  if (typeof value === "number" && value <= 0) {
    return "⦁";
  } else return nf(value, format, { locale: "en-US" });
};
